const arrPopHead = (arr) => {
  return [...arr.filter((item, index) => index !== 0)]
}

const arrPush = (arr, item, max) => {
  let newArr = [...arr]
  if (newArr.length === max) {
    newArr = arrPopHead(newArr)
  }
  return [...newArr, item]
}

const arrRemove = (arr, index) => {
  return [...arr.filter((item, itemIndex) => itemIndex !== index)]
}

/**
 * Actions
 */
const NOTIFICATION_PUSH = 'notification/push'
const NOTIFICATION_POP_HEAD = 'notification/pop-head'
const NOTIFICATION_REMOVE = 'notification/remove'

/**
 * Action Creators
 */
export const push = (item) => ({ type: NOTIFICATION_PUSH, item }) // { severity, title, description }
export const popHead = () => ({ type: NOTIFICATION_POP_HEAD })
export const remove = (index) => ({ type: NOTIFICATION_REMOVE, index })

/**
 * Initial State
 *
 * Stack Children
 *
 * {
 *   title: string,
 *   description: string
 *   severity: 'success' || 'error
 * }
 *
 */
const initialState = {
  stack: [],
  // 'push' || 'popHead' || 'remove'
  action_type: null,
  max: 3,
}

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NOTIFICATION_PUSH:
      return {
        ...state,
        action_type: 'push',
        stack: arrPush(state.stack, action.item, state.max),
      }
    case NOTIFICATION_POP_HEAD:
      return {
        ...state,
        action_type: 'popHead',
        stack: arrPopHead(state.stack),
      }
    case NOTIFICATION_REMOVE:
      return {
        ...state,
        action_type: 'remove',
        stack: arrRemove(state.stack, action.index),
      }
    default:
      return state
  }
}
